<template>
	<div style="background: #f3f4f7" v-loading.fullscreen.lock="fullscreenLoading">
		<userHeader />
		<crumbs :txt="a" :crumFlag="crumFlag" type="2" height="53px" />
		<div class="bodyWrapper">
			<div class="gudBtns">
				<div class="gudBtnItem gudBack supHove3" @click="$router.back()">
					<img src="@/assets/img/back.svg" alt="" />
					<span>返回</span>
				</div>
			</div>
			<div class="mqBox">
				<div class="mqBoxTop">
					<div class="mqBoxTopBtns">
						<img src="@/assets/img/fxIcon.svg" alt="" />
						<span>分享小程序</span>
						<div class="erwB">
							<img :src="qrCodeImage" alt="" />
							<p>微信扫码分享</p>
						</div>
					</div>
					<div class="mqBoxTit">
						<span>日期：{{ (mrData.releaseTime || mrData.createTime) | momentYR('YYYY年MM月DD日') }}</span>
						<!-- <span>编写人：{{mrData.createNickName}}</span> -->
					</div>
					<div class="mqBoxTopCont">
						<div class="mqBoxTopImg">
							<img :src="$imgUrl + mrData.coverImg" alt="" />
						</div>
						<div class="mqBoxTopR">
							<h2>本期看点</h2>
							<p v-html="mrData.content"></p>
						</div>
					</div>
				</div>
				<div class="mqBoxBot">
					<div class="zzAdminTabs">
						<div class="zzAdminTab">
							<div class="zzAdminItem supHove2" :class="item.type == tabFlag ? 'active' : ''" @click="tabFn(item)" v-for="item in tabData" :key="item.type">
								{{ item.name }}
							</div>
						</div>
					</div>
					<div class="zzAdminConts">
						<div class="zzAdminCont" v-show="perData.length">
							<div class="zzAdminG supHove5" v-for="(item, index) in perData" :key="index" @click="btnFn(item)">
								<div class="zzAdminItemImg" v-show="tabFlag == 1 || tabFlag == 2 || tabFlag == 3">
									<el-image :src="$imgUrl + item.coverImg" lazy></el-image>
								</div>
								<div class="zzAdminItemImg zzAdminItemImg1" v-show="tabFlag == 4 || tabFlag == 5">
									<div>
										<img :src="$imgFn(item.resourceFileName, 1)" alt="" />
									</div>
								</div>
								<div class="zzAdminItemP" v-if="tabFlag == 1 || tabFlag == 2 || tabFlag == 3">
									<div class="zzAdminItemTit">
										<p :title="item.title">{{ item.title }}</p>
									</div>
									<div class="zzAdminItemJj">
										<div class="zzAdminItemJjI" :class="`zzAdminItemJjI${(index + 1) % 6}`" v-for="(i, index) in item.keywords?.split(',')" :key="index">
											{{ i }}
										</div>
									</div>
									<div class="zzAdminItemC" v-html="$extractText(item.content || '')" :title="$extractText(item.content || '')"></div>
								</div>
								<div class="zzAdminItemP" v-else>
									<div class="zzAdminItemTit">
										<p :title="item.title">{{ item.title }}</p>
										<div class="infoMyVip infoMyPut" v-if="item.limitsAuthority == 0">
											<i class="el-icon-user-solid"></i>
											<span>普通老师</span>
										</div>
										<div class="infoMyVip" v-if="item.limitsAuthority == 1">
											<img src="@/assets/img/hys.svg" alt="" />
											<span>会员老师</span>
										</div>
										<!-- <div class="zzAdminItemYuy" @click.stop="scFn(item)" :class="item.isCollect?'active':''">
						<img src="@/assets/img/sc (4).svg" v-show="!item.isCollect" alt="">
						<img src="@/assets/img/sc (2).svg" v-show="item.isCollect" alt="">
						<span>{{item.isCollect?'已收藏':'收藏'}}</span>
					  </div> -->
									</div>
									<div class="zzAdminItemFot">
										<div class="zzAdminItemk">
											<img src="@/assets/img/xiazai.svg" alt="" />
											<span>下载量：{{ item.downloadNum || 0 }}</span>
										</div>
										<div class="zzAdminItemk">日期：{{ (item.releaseTime || item.createTime) | momentYR('YYYY年MM月DD日') }}</div>
										<!-- <div class="zzAdminItemk">
						  编写人：{{item.createNickName}}
						</div> -->
									</div>
								</div>
							</div>
							<!-- <fenye :total="total" ref="fybox" @dataFn="perList" /> -->
						</div>
						<div class="zzAdminCont zzAdminCont1" v-show="!perData.length">
							<el-empty description="暂无内容"></el-empty>
						</div>
					</div>
				</div>
			</div>
		</div>
		<foot />
	</div>
</template>

<script>
import foot from '@/components/foot/foot';
import crumbs from '@/components/hearder/crumbs';
import userHeader from '@/components/hearder/userHeader';
import fenye from '@/components/pubComponents/fenye';

export default {
	name: 'mqDec',
	data() {
		return {
			type: 1, // 1文章 2视频 3音乐 4试卷
			txt: '',
			tabFlag: 5,
			tabData: [
				{
					name: '本期课件',
					type: 5
				},
				{
					name: '试卷',
					type: 4
				},
				{
					name: '美文',
					type: 3
				},
				{
					name: '演讲',
					type: 2
				},
				{
					name: '歌曲',
					type: 1
				}
			],
			coursewarePeriodId: '',
			a: ['个人中心'],
			mrData: '',
			fullscreenLoading: false,
			total: 0,
			perData: [],
			crumFlag: false,
			qrCodeImage: ''
		};
	},
	components: {
		userHeader,
		crumbs,
		foot,
		fenye
	},
	methods: {
		ewmaFn() {
			let url = '';
			// 课件分享
			url = `pages/search/resources/resource-list?id=${this.coursewarePeriodId}`;
			this.$http
				.get('api/app/common/getMiniProgramsCodes', {
					params: {
						url,
						clientType: '1'
					},
					responseType: 'blob'
				})
				.then((res) => {
					if (res) {
						const blob = new Blob([res], { type: 'image/png' });
						this.qrCodeImage = URL.createObjectURL(blob);
					}
				});
		},
		tabFn(item) {
			this.tabFlag = item.type;
			if (this.$refs['fybox']) {
				this.$refs['fybox'].pageNum = 1;
				this.$refs['fybox'].pageSize = 10;
			}
			this.perList();
		},
		scFn(item) {
			this.$scFn(
				{
					type: '2',
					assetsId: item.documentResourceId
				},
				item.isCollect,
				this.perList,
				{
					pageNum: this.$refs['fybox']?.pageNum,
					pageSize: this.$refs['fybox']?.pageSize
				}
			);
		},
		btnFn(item) {
			let str = this.a[1] + '~' + item.title;
			sessionStorage.setItem('tabFlag', this.tabFlag);
			if ((this.tabFlag != 4) & (this.tabFlag != 5)) {
				this.$router.push({
					path: './scDec',
					query: {
						type: 1,
						txt: str,
						webpageResourceId: item.webpageResourceId,
						tabFtxt: this.a[0],
						crumFlag: 1,
						tabFtxt: ['首页', '歌曲列表']
					}
				});
			} else {
				this.$router.push({
					path: './hbDec',
					query: {
						type: 5,
						flags: 1,
						txt: item.title,
						classType: 11, // 每期课件
						documentResourceId: item.documentResourceId,
						yzType: 1,
						crumFlag: 1,
						tabFtxt: ['首页', '每期课件']
					}
				});
			}
		},
		init() {
			this.fullscreenLoading = true;
			this.$http.get(`/api/app/yydCoursewarePeriod/${this.coursewarePeriodId}`).then((res) => {
				this.fullscreenLoading = false;
				if (res.code == 200) {
					this.mrData = res.data;
				}
			});
		},
		perList(data) {
			let pre = '';
			if (data) {
				pre = {
					pageNum: data.pageNum,
					pageSize: this.$refs['fybox']?.pageSize || 10
				};
			} else {
				pre = {
					pageNum: this.$refs['fybox']?.pageNum,
					pageSize: this.$refs['fybox']?.pageSize
				};
			}
			this.fullscreenLoading = true;

			this.$http
				.get(`/api/app/yydCoursewareResource/list`, {
					params: {
						type: this.tabFlag,
						coursewarePeriodId: this.coursewarePeriodId
						// ...pre,
					}
				})
				.then((res) => {
					this.fullscreenLoading = false;
					if (res.code == 200) {
						this.perData = res.data || [];
						// this.total = res.total
					}
				});
		}
	},
	mounted() {
		const { type, txt, tabFtxt, coursewarePeriodId, crumFlag } = this.$route.query;
		if (tabFtxt) {
			this.a = typeof tabFtxt == 'string' ? [tabFtxt] : [...tabFtxt];
		}
		if (sessionStorage.getItem('tabFlag')) {
			this.tabFlag = sessionStorage.getItem('tabFlag');
			sessionStorage.removeItem('tabFlag');
		}
		this.coursewarePeriodId = coursewarePeriodId;
		this.type = type || 1;
		this.txt = txt || '';
		this.a.push(txt);
		this.ewmaFn();
		this.init();
		this.perList();
		if (crumFlag) {
			this.crumFlag = true;
		}
	}
};
</script>
<style lang="scss" scoped>
.mqBox {
	width: 1200px;
	margin: 0 auto 10px;
	.mqBoxTop {
		margin-bottom: 10px;
		background: #fff;
		border-radius: 6px;
		padding: 9px 17px 14px;
		position: relative;
		.mqBoxTit {
			height: 47px;
			display: flex;
			align-items: center;
			color: #8f9190;
			font-size: 12px;
			span {
				margin-right: 27px;
			}
		}
		.mqBoxTopBtns {
			position: absolute;
			cursor: pointer;
			right: 14px;
			top: 14px;
			width: 113px;
			height: 36px;
			background: #1d7b3a;
			border-radius: 7px;
			border: 1px solid #14652d;
			color: #fff;
			font-size: 14px;
			display: flex;
			align-items: center;
			justify-content: center;
			&:hover {
				.erwB {
					display: block;
				}
			}
			img {
				width: 13px;
				height: 14px;
				margin-right: 7px;
			}
			.erwB {
				position: absolute;
				top: 45px;
				left: 0;
				padding: 9px 12px 0;
				z-index: 99999;
				background: #fff;
				border-radius: 15px;
				display: none;
				box-shadow: 0px 6px 15px 0px rgba(0, 0, 0, 0.16);
				img {
					width: 145px;
					height: 145px;
					margin: 0;
					vertical-align: bottom;
				}
				p {
					height: 30px;
					line-height: 30px;
					font-size: 12px;
					color: #000000;
					text-align: center;
				}
			}
		}
		.mqBoxTopCont {
			display: flex;
			.mqBoxTopImg {
				margin-right: 105px;
				img {
					width: 432px;
					height: 274px;
					object-fit: cover;
				}
			}
			.mqBoxTopR {
				padding-top: 10px;
				h2 {
					color: #000000;
					font-size: 16px;
					font-weight: bold;
					margin-bottom: 9px;
				}
				p {
					color: #333333;
					font-size: 14px;
					line-height: 2;
				}
			}
		}
	}
}
.mqBoxBot {
	.zzAdminConts {
		background: #ffffff;
		border-radius: 0px 0px 6px 6px;
		padding: 0 18px 20px;
		.zzAdminCont {
			margin-bottom: 10px;
			.zzAdminG {
				display: flex;
				padding: 15px 0;
				border-bottom: 1px solid #f8f8f8;
				align-items: center;
				cursor: pointer;
				&:last-of-type {
					border-bottom: none;
				}
				.zzAdminItemImg {
					width: 149px;
					height: 99px;
					cursor: pointer;
					margin-right: 10px;
					div {
						width: 100%;
						height: 100%;
						overflow: hidden;
					}
					img {
						width: 100%;
						height: 100%;
						border-radius: 12px;
						object-fit: cover;
					}
				}
				.zzAdminItemImg1 {
					width: 65px;
					height: 65px;
				}
				.zzAdminItemP {
					cursor: pointer;
					flex: 1;
					.zzAdminItemJj {
						display: flex;
						align-items: center;
						.zzAdminItemJjI {
							padding: 0 10px;

							height: 20px;
							font-size: 12px;
							text-align: center;
							line-height: 20px;
							border-radius: 4px;
							margin-right: 10px;
							margin-bottom: 5px;
						}
						.zzAdminItemJjI0 {
							background: #fef7f0;
							color: #f7860f;
						}
						.zzAdminItemJjI1 {
							background: #fef7f0;
							color: #f7860f;
						}
						.zzAdminItemJjI2 {
							background: #f6fcf1;
							color: #5ec009;
						}
						.zzAdminItemJjI3 {
							background: #f1f7fe;
							color: #1675e5;
						}
						.zzAdminItemJjI5 {
							background: #fbf3ff;
							color: #bf2ff9;
						}
						.zzAdminItemJjI4 {
							background: #f2f7f3;
							color: #1d7b3a;
						}
					}
					.zzAdminItemFot {
						display: flex;
						align-items: center;
						.zzAdminItemk {
							display: flex;
							align-items: center;
							color: #8f9190;
							font-size: 12px;
							margin-right: 29px;
							img {
								width: 15px;
								height: 15px;
								margin-right: 4px;
							}
						}
					}
					.zzAdminItemC {
						color: #aeaeae;
						font-size: 14px;
						margin-bottom: 5px;
						display: -webkit-box;
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 2;
						overflow: hidden;
						text-overflow: ellipsis;
						padding-right: 20px;
					}
					.zzAdminItemTit {
						display: flex;
						align-items: center;
						margin-bottom: 6px;
						p {
							font-size: 16px;
							color: #000000;
							font-weight: bold;
							max-width: 800px;
							overflow: hidden; /* 确保超出容器的内容被裁剪 */
							white-space: nowrap; /* 确保文本在一行内显示 */
							text-overflow: ellipsis; /* 超出部分显示省略号 */
						}
						.zzAdminItemYuy {
							display: flex;
							align-items: center;
							color: #999999;
							font-size: 14px;
							margin-left: 25px;
							line-height: 1;
							img {
								width: 14px;
								height: 14px;
								vertical-align: bottom;
								margin-right: 5px;
							}
						}
						.active {
							color: #1d7b3a;
						}
					}
				}
				.zzAdminItemDel {
					flex: 1;
					width: 20px;
					height: 22px;
					margin-right: 32px;
					cursor: pointer;
					text-align: right;
				}
			}
		}
		.zzAdminCont1 {
			padding-bottom: 20px;
		}
	}
	.zzAdminTabs {
		height: 60px;
		background: #ffffff;
		border-radius: 6px 6px 0px 0px;
		display: flex;
		justify-content: space-between;
		padding: 0 15px 0 26px;
		border-bottom: 1px solid #f3f4f7;
		.zzAdminTab {
			display: flex;
			font-size: 18px;
			color: #979797;
			align-items: center;
			.zzAdminItem {
				margin-right: 52px;
				cursor: pointer;
			}
			.active {
				color: #000;
				font-weight: bold;
			}
		}
		.zzAdminUp {
			display: flex;
			align-items: center;
			color: #1d7b3a;
			font-size: 14px;
			height: 100%;
			cursor: pointer;
			img {
				width: 16px;
				height: 16px;
				margin-right: 7px;
			}
		}
	}
}
.zzAdminItemFot {
	display: flex;
	align-items: center;
	.zzAdminItemk {
		display: flex;
		align-items: center;
		color: #8f9190;
		font-size: 12px;
		margin-right: 29px;
		img {
			width: 15px;
			height: 15px;
			margin-right: 4px;
		}
	}
}
.infoMyVip {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 75px;
	height: 18px;
	background: linear-gradient(90deg, #fde6d1 0%, #fdd7b3 100%);
	border-radius: 4px;
	color: #93571c;
	font-size: 12px;
	margin-left: 10px;

	img {
		width: 14px;
		height: 14px;
		margin-right: 2px;
	}
}
.infoMyPut {
	background: linear-gradient(90deg, rgba(97, 161, 255, 0.22) 0%, rgba(0, 118, 255, 0.31) 100%);
	color: #0c7bfd;
	i {
		font-size: 14px;
		margin-right: 2px;
		line-height: 1.2;
	}
}
</style>
